<template>
  <div class="ApplyDialog" v-if="applyDialogShow">
    <div class="dialog-container">
      <div class="dialog-title">
        {{ title }}
        <div class="title-close-btn" @click="applyDialogShow = false"></div>
      </div>
      <div class="dialog-content">
        <div class="content-tips">
          请留下您的联系方式，我们将尽快与您取得联系！
        </div>
        <div class="content-form">
          <div class="form-item">
            <div class="item-left">
              <span class="icon-sign">*</span>
              称呼：
            </div>
            <div class="item-right">
              <el-input v-model="form.name" placeholder="请输入称呼"></el-input>
            </div>
          </div>
          <div class="form-item">
            <div class="item-left">
              <span class="icon-sign">*</span>
              手机：
            </div>
            <div class="item-right">
              <el-input
                v-model="form.phone"
                placeholder="请输入手机号码"
              ></el-input>
            </div>
          </div>
          <div class="form-item">
            <div class="item-left">公司：</div>
            <div class="item-right">
              <el-input
                v-model="form.company"
                placeholder="请输入公司名称"
              ></el-input>
            </div>
          </div>
          <div class="form-item">
            <div class="item-left">职位：</div>
            <div class="item-right">
              <el-input
                v-model="form.position"
                placeholder="请输入职位"
              ></el-input>
            </div>
          </div>
          <div class="form-item">
            <div class="item-left">需求：</div>
            <div class="item-right">
              <el-input
                type="textarea"
                v-model="form.demand"
                placeholder="请输入需求描述"
                rows="5"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="content-btn">
          <div class="btn btn-apply" @click="onSubmit">提交申请</div>
          <div class="btn btn-reset" @click="onReset">重置</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/common/event-bus";
import * as IndexRequest from "@/api/index";

export default {
  name: "ApplyDialog",
  data() {
    return {
      applyDialogShow: false,
      form: {
        name: null,
        phone: null,
        company: null,
        position: null,
        demand: null,
      },
      title: "",
      formType: null,
    };
  },
  watch: {
    applyDialogShow(nv) {
      if (!nv) {
        this.onReset();
      }
    },
  },
  beforeDestroy() {
    EventBus.$off("openApplyDialog", this.openApplyDialog);
  },
  mounted() {
    EventBus.$on("openApplyDialog", this.openApplyDialog);
  },
  methods: {
    openApplyDialog(params) {
      if (params.type == 1) {
        this.title = "免费方案申请";
      } else if (params.type == 2) {
        this.title = "产品代理申请";
      } else if (params.type == 3) {
        this.title = "产品定制申请";
      } else if (params.type == 4) {
        this.title = "开发者平台申请加入";
      }
      this.formType = params.type;
      this.applyDialogShow = true;
    },
    onSubmit() {
      if (!this.form.name) {
        this.$message.error("请输入称呼！");
        return;
      }
      if (!this.form.phone) {
        this.$message.error("请输入手机号码！");
        return;
      }
      if (!/^1[3456789]\d{9}$/.test(this.form.phone)) {
        this.$message.error("手机号码格式不正确！");
        return;
      }
      this.form.type = this.formType; // 表单类型：1-试用；2-代理
      this.form.origin = 1; // 线索来源：1-PC端；2-移动端
      this.form.extra = JSON.stringify({
        router: this.$router.currentRoute.name || location.href,
      });
      IndexRequest.apply(this.form)
        .then((res) => {
          if (res?.data?.code == 0) {
            this.applyDialogShow = false;
            this.$message.success("申请提交成功！");
            this.onReset();
          } else {
            this.$message.error("申请提交失败，请重新提交！");
          }
        })
        .catch((err) => {
          console.log("err:", err);
          this.$message.error("网络错误，请重新提交！");
        });
    },
    onReset() {
      this.form = {
        name: null,
        phone: null,
        company: null,
        position: null,
        demand: null,
      };
    },
  },
};
</script>


<style lang="less" scoped>
.ApplyDialog {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: #00000080;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9;

  .dialog-container {
    background: #000000;
    border-radius: 8px;
    overflow: hidden;

    .dialog-title {
      background: #141414;
      font-size: 24px;
      text-align: center;
      position: relative;
      line-height: 62px;

      .title-close-btn {
        width: 16px;
        height: 16px;
        position: absolute;
        top: 50%;
        right: 40px;
        transform: translate(0, -50%);
        background: url("https://bdbcdn.bdbdigital.com/websit/web/close.png")
          no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
      }
    }

    .dialog-content {
      .content-tips {
        margin: 30px 0;
        font-size: 18px;
        text-align: center;
      }

      .content-form {
        padding: 0 30px 0;

        .form-item {
          display: flex;
          align-items: start;
          justify-content: center;
          margin-bottom: 30px;

          .item-left {
            margin: 8px 24px 0 0;
            padding-left: 8px;
            position: relative;

            .icon-sign {
              color: #a6000d;
              position: absolute;
              top: 0;
              left: 0;
            }
          }

          .item-right {
            width: 500px;

            ::v-deep .el-input__inner,
            ::v-deep .el-textarea__inner {
              background-color: #141414;
              border-color: #141414;
              font-family: Microsoft YaHei;
              color: #bfbfbf;
              font-size: 18px;

              &::placeholder {
                color: #8c8c8c;
              }
            }
          }
        }
      }

      .content-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 30px;

        .btn {
          width: 142px;
          line-height: 38px;
          text-align: center;
          font-size: 18px;
          border-radius: 8px;
          cursor: pointer;
          border: 1px solid #ffffff;

          &:hover {
            background: #ffffff1a;
          }

          &.btn-apply {
            margin-right: 24px;
            background: #a6000d;
            border-color: #a6000d;

            &:hover {
              background: #80000f;
              border-color: #80000f;
            }
          }
        }
      }
    }
  }
}
</style>